import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import CustomSelectDropdown from '../../../../../components/CustomSelectDropDown';
import PrimaryButton from '../../../../../components/Button/Button';
import GlobalSearch from '../../../../../components/Search';

const FilterButton = ({ selected, onClick, dropdownOptions, filterButtons }) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const [status, setStatus] = useState(selected);

  const updateStatus = (key, value) => {
    setStatus(value);
    onClick(value);
  };
 return isMobile ? (
          <CustomSelectDropdown
            options={dropdownOptions}
            label="Filter by Status"
            onSelectChange={(value) => updateStatus("status", value)}
            defaultValue={status}
          />
        ) : (
          filterButtons.map((btn, idx) => (
            <PrimaryButton
              variant="contained"
              key={idx}
              className={`capitalize pending-requests-filter-btn ${
                btn.value === status ? "btn-bg-grey" : "btn-bg-light-grey"
              }`}
              onClick={() => updateStatus("status", btn.value)}
            >
              {btn.label}{" "}
              <span
                className={`${
                  btn.value === status ? "survey-count-select" : "survey-count"
                }`}
              >{` ${btn.total}`}</span>
            </PrimaryButton>
          ))
        )
};

const Filters = ({ filter, setFilter }) => {
  return (
    <div className="pending-requests-filters">
      <div className="filter-buttons">
        {/* <FilterButton
          selected={filter}
          onClick={setFilter}
          dropdownOptions={dropdownOptions}
          filterButtons={filterButtons}
        /> */}
      </div>
      <GlobalSearch />
    </div>
  );
};

export default Filters; 